import { MathUtils } from 'three'

// Deterministic per-coordinate hash — no global state, call-order independent
export function coordHash(x: number, z: number, salt = 0): number {
  const ix = Math.round(x * 1000)
  const iz = Math.round(z * 1000)
  let h = (ix * 374761393 + iz * 668265263 + salt * 2246822519) >>> 0
  h ^= h >>> 13
  h = Math.imul(h, 1540483477) >>> 0
  h ^= h >>> 15
  return (h >>> 0) / 0xffffffff
}

export const random = (min: number, max: number, precision = 3) => {
  const factor = Math.pow(10, precision)
  return Math.round((Math.random() * (max - min) + min) * factor) / factor
}

export const randomInt = (min: number, max: number) => random(min, max, 0)

export const randomColor = () => `hsl(${Math.random() * 360}, 50%, 50%)`

export const randomAngle = () => random(0, Math.PI * 2)

export const randomOneOf = <T>(array: T[]) => {
  return array[Math.floor(Math.random() * array.length)]
}

let randomSeed = Math.random()
export const seededRandom = () => {
  const r = MathUtils.seededRandom(randomSeed)
  randomSeed += 1
  return r
}
